module.exports = __webpack_public_path__ + "media/img/illustrations/icons/table-escalation-arrow-1abb80ac3ee829862107a259c5dbdc26.svg";